import { render, staticRenderFns } from "./goodPtw.vue?vue&type=template&id=301d872e&scoped=true&"
import script from "./goodPtw.vue?vue&type=script&lang=js&"
export * from "./goodPtw.vue?vue&type=script&lang=js&"
import style0 from "./goodPtw.vue?vue&type=style&index=0&id=301d872e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d872e",
  null
  
)

export default component.exports